<style scoped>
.content-wrapper .content {
    padding-top: 95px;
}
.heading-cart {
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
}
.m-t-5 {
    margin-top: 10px;
}
.heading-cart {
    margin-bottom: 0;
}
.el-select {
    display: block;
}
.el-button.edit {
    padding: 5px 10px;
}
.flash {
    background: none !important;
}
.el-select-dropdown__item {
    max-width: 550px;
}
.col {
    width: 32%;
}
</style>
<style type="text/css">
.import .el-button {
    padding: 7px 10px;
}
.el-table .warning-row,
.el-table table.el-table__body tr.el-table__row.warning-row > td {
    background: oldlace;
}
</style>
<template>
    <div class="content-wrapper">
        <section class="content">
            <div class="box">
                <div class="box-header with-border heading-cart clearfix">
                    <div class="clearfix pull-left col-md-12">
                        <div style="margin-bottom: 30px">
                            <h3 class="box-title" style="font-size: 20px; margin-left: -17px;">Adspots Layouts Association</h3>

                            <div
                                class="pull-right clearfix import"
                                style="padding: 5px; padding-top: 0px; padding-right: 15px"
                            >
                                <div class="col-md-9 text-right">
                                    <el-dropdown trigger="click" @command="selectedBucket" v-show="!importedData">
                                        <el-button type="primary">
                                            Import Config
                                            <i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                v-for="(bucket, index) in importBuckets"
                                                :key="'bucketindex' + index"
                                                :command="index"
                                                >{{ bucket.bucketName }}</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <button
                                        class="el-button el-button--danger"
                                        @click="removeImport()"
                                        v-show="importedData"
                                    >
                                        Remove
                                    </button>
                                </div>
                                <div class="col-md-3 no-padding">
                                    <button
                                        class="el-button el-button--success"
                                        @click="saveImportedData()"
                                        :disabled="!importedData"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="formLoadingDone">
                            <div class="row">
                                <span style= "margin-left:5px" class="m-l-20 form-label">Ad Spots:</span>
                                <el-select
                                    style="display: inline-block; max-width: 215px"
                                    class="col"
                                    v-model="filterData.adSpotId"
                                    placeholder="Search and select ad spot"
                                    :key="randomNumber"
                                    :loading="dropdownLoading.adSpot"
                                    multiple
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="(adspot, index) in allIndividualAdspots"
                                        :key="'alias name' + index"
                                        :label="adspot.alias_name"
                                        :value="adspot.id"
                                    >
                                        {{ adspot.alias_name }}
                                    </el-option>
                                </el-select>
                                <span style= "margin-left:10px" class="m-l-20 form-label">Unique Id:</span>
                                <el-select
                                    :loading="dropdownLoading.adSpot"
                                    style="display: inline-block; max-width: 215px"
                                    class="col"
                                    :value="fakeAdSpotId"
                                    @input="setUniqueOrAdFormat"
                                    placeholder="Search and select unique id"
                                    multiple
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        style="width: 100%"
                                        v-for="(adspot, index) in getUniqueOrAdFormat()"
                                        :key="'unique id keys' + index"
                                        :label="
                                            adspot.is_existing ? adspot.unique_id : getAdTypeName(adspot.fi_ad_type)
                                        "
                                        :value="adspot.id"
                                    >
                                        {{ adspot.is_existing ? adspot.unique_id : getAdTypeName(adspot.fi_ad_type) }}
                                    </el-option>
                                </el-select>
                                <div style="display:inline-block">
                                <span style= "margin-left:10px" class="m-l-20 form-label">Layout:</span>
                                <el-select
                                    :loading="dropdownLoading.adLayout"
                                    style="display: inline-block; width: 215px"
                               
                                    v-model="filterData.adLayout"
                                    placeholder="Search and select layout"
                                    multiple
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="(layout, index) in allIndividualLayouts"
                                        :key="'layout keys' + index"
                                        :label="layout.layout_name"
                                        :value="layout.id"
                                    >
                                        {{ layout.layout_name }}
                                    </el-option>
                                </el-select>
                            </div>
                            </div>

                            <div
                                style="
                                    display: flex;
                                    justify-content: space-between;
                                    padding-top: 10px;
                                    padding-right: 7px;
                                    margin-left: 5px;
                                "
                            >
                                <div style="flex: auto">
                                <span style= "margin-left:-16px" class="m-l-20 form-label">Tag Name:</span>
                                    <el-select
                                        :loading="dropdownLoading.adHbAdUnit"
                                        style="display: inline-block; max-width: 208px; margin-top: 10px"
                                        class="col"
                                        v-model="filterData.adHbAdUnit"
                                        placeholder="Search and select tag name"
                                        multiple
                                        clearable
                                        filterable
                                    >
                                        <el-option
                                            style="width: 100%"
                                            v-for="(hb_id, index) in allIndividualHBAdUnits"
                                            :key="'tagnamekeys' + index"
                                            :label="hb_id.name"
                                            :value="hb_id.id"
                                        >
                                            <!-- {{ getTagName(adspot) }} -->
                                            {{ hb_id.name }}
                                        </el-option>
                                    </el-select>
                                    <span style= "margin-left:10px" class="m-l-20 form-label">Dimension:</span>

                                    <el-select
                                        style="display: inline-block; max-width: 300px"
                                        v-model="filterData.adDimensions"
                                        placeholder="Select dimensions"
                                        multiple
                                        clearable
                                        filterable
                                    >
                                        <el-option
                                            style="width: 100%"
                                            v-for="(dimension, index) in dimensions"
                                            :key="'abc' + index"
                                            :label="`${dimension.width}x${dimension.height}`"
                                            :value="dimension.id"
                                        >
                                        </el-option>
                                    </el-select>
                                    <span style= "margin-left:43px" class="m-l-20 form-label">Status:</span>
                                    <el-radio-group
                                        size="medium"
                                        v-model="filterData.adIsLive"
                                        style="display: inline-block; max-width: 300px; height: 40px"
                                    >
                                        <el-radio-button :label="null">All</el-radio-button>
                                        <el-radio-button :label="true">Live</el-radio-button>
                                        <el-radio-button :label="false">Demo</el-radio-button>
                                    </el-radio-group>

                                    <el-button
                                        style="margin-top: 10px"
                                        class="pull-right m-t-10"
                                        size="medium"
                                        type="danger"
                                        @click="clearFilter()"
                                    >
                                        Clear Filters
                                    </el-button>
                                </div>
                            </div>
                            <!-- {{allAssociatedAdSpots.length}} -->
                        </div>
                        <span class="text-danger animated flash config-notif" v-if="importedData">
                            Imported config from
                            {{ selectedBucketData.bucketName }} Bucket. Click save to use the config.
                        </span>
                    </div>
                </div>
                <div class="box-body">
                    <el-table
                        height="400"
                        v-loading="loading"
                        :data="associatedAdSpots"
                        style="width: 100%; border-spacing: 0"
                        id="assoc-table"
                    >
                        <el-table-column label="Alias Name" width="120">
                            <template slot-scope="props">
                                {{ props.row.layout.ad_spot.alias_name }}
                                <span v-if="!props.row.layout.ad_spot.is_existing">
                                    ({{ getAdTypeName(props.row.layout.ad_spot.fi_ad_type) }}
                                    ad format)
                                </span>
                                <br />
                                <router-link
                                    :to="{
                                        path: `/admin/publisher/${uuid}/domain/${domId}/ad-spot-setup/`,
                                        query: {
                                            spot_id: props.row.layout.ad_spot.id,
                                        },
                                    }"
                                >
                                    View ad spot
                                </router-link>
                            </template>
                        </el-table-column>

                        <el-table-column label="Unique Id / Ad Format">
                            <template slot-scope="props">
                                <span>{{
                                    getAdTypeName(props.row.layout.ad_spot.fi_ad_type) != '-'
                                        ? getAdTypeName(props.row.layout.ad_spot.fi_ad_type)
                                        : props.row.layout.ad_spot.unique_id
                                }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="Layout" prop="layout.layout.layout_name" width="100"></el-table-column>
                        <el-table-column label="HB?" width="50">
                            <template slot-scope="props">
                                <div v-if="props.row.is_hb" class="text-center">
                                    <svg
                                        data-v-7a40f996=""
                                        aria-hidden="true"
                                        height="20px"
                                        width="20px"
                                        data-prefix="far"
                                        data-icon="check-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="svg-inline--fa fa-check-circle fa-w-16 fa-2x"
                                    >
                                        <path
                                            data-v-7a40f996=""
                                            fill="green"
                                            d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                                        ></path>
                                    </svg>
                                </div>
                                <div v-if="!props.row.is_hb" class="text-center">
                                    <svg
                                        aria-hidden="true"
                                        height="20px"
                                        width="20px"
                                        data-prefix="fal"
                                        data-icon="times-circle"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        class="svg-inline--fa fa-times-circle fa-w-16 fa-2x"
                                    >
                                        <path
                                            fill="red"
                                            d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"
                                            class=""
                                        ></path>
                                    </svg>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Tag Name">
                            <template slot-scope="props">
                                {{
                                    props.row.is_hb
                                        ? getAdunitPath(props.row.hb_id)
                                        : props.row.dfp_id.dfp_network.network_code +
                                          '/' +
                                          props.row.dfp_id.ad_unit_name
                                }}
                            </template>
                        </el-table-column>
                        <el-table-column label="Edit" width="50">
                            <template slot-scope="props">
                                <button
                                    class="el-button btn-rounded el-button--success edit"
                                    @click="editAdSpotTagAssoc(props.row)"
                                >
                                    <i class="ti-pencil"></i>
                                </button>
                            </template>
                        </el-table-column>
                        <el-table-column label="Delete" width="70">
                            <template slot-scope="props">
                                <button
                                    class="el-button btn-rounded el-button--danger edit"
                                    @click="deleteAdSpotTagAssoc(props.row)"
                                >
                                    <i class="ti-close"></i>
                                </button>
                            </template>
                        </el-table-column>
                        <el-table-column label="Dimension/s" width="150">
                            <template slot-scope="props">
                                <div class="col-md-10">
                                    <p
                                        style="margin: 0px; font-size: 13px"
                                        :key="'agedlsf' + dimension.id"
                                        v-for="dimension in props.row.dimensions"
                                    >
                                        {{ dimension.width }} X
                                        {{ dimension.height }}
                                    </p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="Status" width="60">
                            <template slot-scope="props">
                                <div class="col-md-10">
                                    <el-tooltip content="live" v-if="props.row.is_live" placement="top">
                                        <i class="el-icon-success" style="color: green"></i>
                                    </el-tooltip>
                                    <el-tooltip content="demo" v-else placement="top">
                                        <i class="el-icon-error" style="color: red"></i>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        style="text-align: center; margin-top: 30px"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage"
                        :page-sizes="[20, 50, 100]"
                        :total="totalPages"
                        layout="sizes, prev, pager, next"
                        :page-size="offset"
                    >
                    </el-pagination>
                    <form
                        ref="create-edit-block"
                        method="post"
                        v-on:submit.prevent="layoutTagAssociation"
                        class="form"
                        v-if="formLoadingDone"
                    >
                        <div class="row">
                            <div class="col-md-3">
                                <h5>Choose Adspot on Layout</h5>
                                <el-select
                                    v-model="formData.layout"
                                    placeholder="Search and select a layout adspot"
                                    filterable
                                    :key="randomNumber"
                                    @change="checkDisabled()"
                                    multiple
                                    clearable
                                >
                                    <el-option
                                        v-for="adspot in allAdSpotsWithLayouts"
                                        :key="
                                            adspot.id +
                                            '-' +
                                            adspot.ad_spot.unique_id +
                                            ' - ' +
                                            adspot.layout.layout_name
                                        "
                                        :label="getLabel(adspot)"
                                        :value="adspot.id"
                                        :disabled="adspot.alreadyAssociated || adspot.alreadyAssigned"
                                    >
                                        {{ getLabel(adspot) }}

                                        <span
                                            v-if="adspot.alreadyAssociated"
                                            style="color: red; font-style: italic; margin-left: 5px"
                                            >USED</span
                                        >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="col-md-1">
                                <h5>HB?</h5>
                                <div class="m-t-5">
                                    <el-switch v-model="formData.hbEnabled" active-color="#13ce66"></el-switch>
                                </div>
                            </div>
                            <div class="col-md-6" v-show="!formData.hbEnabled">
                                <h5>Select DFP Adunit</h5>
                                <el-select
                                    v-model="formData.dfpAdUnit"
                                    placeholder="Search and select a dfp adunit"
                                    filterable
                                    remote
                                    :remote-method="getDfpAdunits"
                                    :loading="loading"
                                    @change="adUnitChange"
                                >
                                    <el-option
                                        v-for="adunit in dfpAdUnits"
                                        :key="adunit.ad_unit_id"
                                        :label="domain_details.dfp_network.network_code + '/' + adunit.ad_unit_name"
                                        :value="adunit.id"
                                    ></el-option>
                                </el-select>
                            </div>
                            <div class="col-md-4" v-show="formData.hbEnabled">
                                <h5>Select Hb Adunit</h5>
                                <el-select
                                    v-model="formData.hbAdUnit"
                                    placeholder="Search and select a HB adunit"
                                    filterable
                                    remote
                                    :remote-method="getHbAdunits"
                                    :loading="loading"
                                    @change="adUnitChange"
                                >
                                    <el-option
                                        v-for="adunit in hbAdUnits"
                                        :key="adunit.id"
                                        :label="getAdunitPath(adunit)"
                                        :value="adunit.id"
                                    >
                                    </el-option>
                                </el-select>
                                <i
                                    v-show="searchingAdUnit"
                                    class="el-icon-loading"
                                    style="position: absolute; top: 50px; right: 20px"
                                ></i>
                            </div>
                            <div class="col-md-2">
                                <h5>Live?</h5>
                                <el-switch v-model="formData.is_live" active-color="#13ce66"></el-switch>
                            </div>
                            <div class="col-md-10" v-if="formData.hbAdUnit || formData.dfpAdUnit">
                                <h5>Choose Dimensions</h5>

                                <el-checkbox-group v-model="formData.checkedDimensions">
                                    <el-checkbox
                                        v-for="dimension in formData.availableDimensions"
                                        class="col-md-2"
                                        :label="dimension.id"
                                        :key="dimension.id"
                                        :disabled="isDisabled(dimension.id)"
                                        :title="
                                            isDisabled(dimension.id) ? 'At least one dimension to be associated' : ''
                                        "
                                    >
                                        {{ dimension.width }} X
                                        {{ dimension.height }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div class="col-md-2">
                                <button
                                    class="el-button btn-rounded el-button--success"
                                    :disabled="
                                        !formData.layout ||
                                        (formData.hbEnabled && !formData.hbAdUnit) ||
                                        (!formData.hbEnabled && !formData.dfpAdUnit) ||
                                        formData.checkedDimensions.length == 0
                                    "
                                >
                                    <i class="ti-save"></i>
                                    {{ !formData.id ? 'Save' : 'Update' }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
import axios from 'axios';
// import LetterAvatar from '../../../../static/plugins/letterAvatar.js';
class UniqueNameSet extends Set {
    constructor(values, uniqueId = false) {
        super(values);

        const ids = [];
        for (let value of this) {
            let uniqueCheck = !uniqueId ? value.id : value['fi_ad_type'];
            if (ids.includes(uniqueCheck)) {
                this.delete(value);
            } else {
                ids.push(uniqueCheck);
            }
        }
    }
}
export default {
    data() {
        return {
            mapAdSpotIdtoFakeIds: {},
            module: 'fi',
            uuid: undefined,
            domId: undefined,
            bucketId: undefined,
            credentialId: undefined,
            fiAdTypes: [],
            associatedAdSpots: [],
            allAssociatedAdSpots: [],
            allAdSpotsWithLayouts: [],
            allIndividualAdspots: [],
            allIndividualLayouts: [],
            allIndividualHBAdUnits: [],
            dfpAdUnits: [],
            hbAdUnits: [],
            allHbAdUnits: [],
            importBuckets: [],
            selectedBucketData: {},
            importedData: false,
            randomNumber: 0,
            formData: {
                index: -1,
                id: undefined,
                layout: undefined,
                hbEnabled: true,
                is_live: false,
                dfpAdUnit: undefined,
                hbAdUnit: undefined,
                dimensions: [],
                checkedDimensions: [],
                availableDimensions: [],
            },
            cancelRequestMethod: null,
            filterData: {
                adSpotId: [],
                adLayout: [],
                adIsLive: null,
                adDfpAdUnit: [],
                adHbAdUnit: [],
                adDimensions: [],
            },
            dropdownLoading: {
                adSpot: true,
                adLayout: true,
                adHbAdUnit: true,
            },
            fakeAdSpotId: [],
            loading: true,
            searchingAdUnit: false,
            totalPages: 0,
            currentPage: 1,
            offset: 20,
            formLoadingDone: false,
            searchFI: '',
            domain_details: undefined,
            filteredAssociatedAdSpots: [],
        };
    },
    computed: {
        computedAdspot() {
            return this.filterData.adSpotId;
        },
    },
    created: function () {
        this.uuid = this.$route.params.uuid;
        this.domId = this.$route.params.domId;
        this.bucketId = this.$route.params.bucketId;
        this.copyFormData = JSON.parse(JSON.stringify(this.formData));
        this.loadAdDimensions();
        this.loadAllAdspots();
        this.loadAllLayouts();
        this.loadAllHBAdunits();
        this.loadAllData();
    },
    watch: {
        filterData: {
            handler(newVal, oldVal) {
                this.getAdspotTagAssociation();
            },
            deep: true,
        },
        computedAdspot: {
            handler() {
                this.fakeAdSpotId = [];
                let addedTypes = [];
                for (let index in this.filterData.adSpotId) {
                    let currAdSpot = this.allIndividualAdspots.filter(
                        (temp) => !temp.is_existing && temp.id == this.filterData.adSpotId[index]
                    );
                    if (currAdSpot.length) {
                        currAdSpot = currAdSpot[0];
                        if (!currAdSpot.is_existing) {
                            if (!addedTypes.includes(currAdSpot.fi_ad_type)) {
                                this.fakeAdSpotId.push(this.mapAdSpotIdtoFakeIds[this.filterData.adSpotId[index]]);
                                addedTypes.push(currAdSpot.fi_ad_type);
                            }
                        }
                    } else this.fakeAdSpotId.push(this.filterData.adSpotId[index]);
                }
            },
        },
    },
    methods: {
        loadAllAdspots() {
            axios
                .get(`${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/setup-fi-adspots/`)
                .then((response) => {
                    this.allIndividualAdspots = response.data.data;
                    this.dropdownLoading.adSpot = false;
                });
        },
        loadAllLayouts() {
            axios.get(BASE_URL + 'v1/domains/' + this.domId + '/page-layouts/').then((response) => {
                this.allIndividualLayouts = response.data;
                this.dropdownLoading.adLayout = false;
            });
        },
        loadAllHBAdunits() {
            axios
                .post(BASE_URL + `v1/get_bucket_hb_units/`, {
                    bucketId: this.$route.params.bucketId,
                })
                .then((response) => {
                    this.allIndividualHBAdUnits = response.data.data;
                    this.dropdownLoading.adHbAdUnit = false;
                });
        },
        loadAllData() {
            axios
                .all([
                    axios.get(BASE_URL + `v1/publishers/${this.uuid}/domains/${this.domId}/`),
                    axios.get(BASE_URL + 'v1/domain/' + this.domId + '/dfp-credentials/'),
                    axios.get(BASE_URL + 'v1/domains/' + this.domId + '/buckets/' + this.bucketId + '/las/'),
                    axios.get(
                        `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${this.bucketId}/adspot-tag-association/`
                    ),
                    axios.get(BASE_URL + 'v1/get-all-fi-ad-types/'),
                    axios.post(BASE_URL + 'v1/get_bucket_config_list/', {
                        bucketId: this.bucketId,
                        module: this.module,
                    }),
                ])
                .then(
                    axios.spread((domain, creadentialId, las, associatedSpots, fi_ad_types, bucketModules) => {
                        this.domain_details = domain.data;
                        this.credentialId = creadentialId.data.id;
                        this.allAdSpotsWithLayouts = las.data;

                        this.associatedAdSpots = associatedSpots.data.data;
                        this.allAssociatedAdSpots = this.allAssociatedAdSpots.concat(associatedSpots.data.data);
                        this.allAdSpotsWithLayouts.forEach((adSpotWithLayout) => {
                            if (this.alreadyAssociated(adSpotWithLayout)) {
                                adSpotWithLayout.alreadyAssociated = true;
                            } else {
                                adSpotWithLayout.alreadyAssociated = false;
                            }
                        });

                        this.totalPages = associatedSpots.data.metadata.count;
                        this.fiAdTypes = fi_ad_types.data;
                        this.importBuckets = bucketModules.data.response_data.bucket_list;
                        // this.allHbAdUnits = all_hb_tags.data.response_data.hb_tags;
                        let query = this.$route.query;
                        let tempFilterData = {};
                        tempFilterData['adIsLive'] = query['adIsLive'] ? query['adIsLive'] == 'true' : null;
                        for (let filterType of ['adLayout', 'adSpotId', 'adHbAdUnit', 'adDimensions']) {
                            tempFilterData[filterType] = query[filterType]
                                ? query[filterType].split(',').map((x) => parseInt(x))
                                : [];
                        }
                        this.getUniqueOrAdFormat(); // Calling this to update the mapAdSpotIdtoFakeIds dictionary.
                        this.filterData.adSpotId = tempFilterData.adSpotId;
                        this.filterData = Object.assign({}, tempFilterData);
                        this.formLoadingDone = true;
                        this.loading = false;
                    })
                );
        },
        getAdunitPath2(k) {
            var domainNetowrkCode = this.domain_details.dfp_network.network_code;
            var domainParentCode = this.domain_details.parent_ad_unit_code;
            this.domainMcmEnabled = this.domain_details.mcm_enable;
            var domainMcmType = this.domain_details.mcm
                ? this.domain_details.mcm.account_type
                : this.domain_details.mcm;
            var domainMcmChild = this.domain_details.child_dfp_network
                ? this.domain_details.child_dfp_network.child_network_code
                : this.domain_details.child_dfp_network;
            var hbAccountType = k.mcm_account_switch;
            var hbOverridenChildNetwork = k.child_network_override;
            var adunitCode = k.dfp_ad_unit_code;
            var hbNetworkOverride = k.network_override;
            var isPubUnit = k.publisher_dfp_unit;
            var ishbNtwrkOverriden = k.network_override == null ? false : true;
            var current_dfp_network = k.current_dfp_network;

            if (k.mcm_account_switch == null) {
                domainParentCode =
                    hbAmp == false
                        ? this.domain_details.parent_ad_unit_code
                        : this.domain_details.amp_parent_ad_unit_code;
            } else {
                if (k.mcm_account_switch == 'MANAGE_ACCOUNT') {
                    domainParentCode = k.dfp_parent_ad_unit_path;
                } else {
                    if (k.dfp_parent_ad_unit_path != 0) {
                        domainParentCode = k.dfp_parent_ad_unit_path;
                    } else {
                        domainParentCode =
                            hbAmp == false
                                ? this.domain_details.parent_ad_unit_code
                                : this.domain_details.amp_parent_ad_unit_code;
                    }
                }
            }

            if (isPubUnit == true) {
                if (hbAccountType) {
                    if (hbAccountType == 'MANAGE_ACCOUNT') {
                        return `${hbOverridenChildNetwork}/${adunitCode}`;
                    } else {
                        // return `${domainNetowrkCode},${hbOverridenChildNetwork}/${adunitCode}`

                        return `${current_dfp_network},${hbOverridenChildNetwork}/${adunitCode}`;
                    }
                } else {
                    if (ishbNtwrkOverriden == true) {
                        return `${hbNetworkOverride}/${adunitCode}`;
                    } else if (current_dfp_network) {
                        return `${current_dfp_network}/${adunitCode}`;
                    } else {
                        if (this.domainMcmEnabled) {
                            if (domainMcmType == 'MANAGE_ACCOUNT') {
                                return `${domainMcmChild}/${adunitCode}`;
                            } else {
                                return `${domainNetowrkCode},${domainMcmChild}/${adunitCode}`;
                            }
                        } else {
                            return `${domainNetowrkCode}/${adunitCode}`;
                        }
                    }
                }
            } else {
                if (hbAccountType) {
                    if (hbAccountType == 'MANAGE_ACCOUNT') {
                        return `${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`;
                    } else {
                        return `${domainNetowrkCode},${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`;
                    }
                } else if (current_dfp_network) {
                    return `${current_dfp_network}/${domainParentCode}/${adunitCode}`;
                } else {
                    if (this.domainMcmEnabled) {
                        if (domainMcmType == 'MANAGE_ACCOUNT') {
                            return `${domainMcmChild}/${domainParentCode}/${adunitCode}`;
                        } else {
                            return `${domainNetowrkCode},${domainMcmChild}/${domainParentCode}/${adunitCode}`;
                        }
                    } else {
                        return `${domainNetowrkCode}/${domainParentCode}/${adunitCode}`;
                    }
                }
            }

            return adunitCode;
        },
        getAdunitPath(k) {
            var hbAmp = k.is_amp;
            var domainNetowrkCode = this.domain_details.dfp_network.network_code;
            var domainParentCode = '';
            if (k.mcm_account_switch == null) {
                domainParentCode =
                    hbAmp == false
                        ? this.domain_details.parent_ad_unit_code
                        : this.domain_details.amp_parent_ad_unit_code;
            } else {
                if (k.mcm_account_switch == 'MANAGE_ACCOUNT') {
                    domainParentCode = k.dfp_parent_ad_unit_path;
                } else {
                    if (k.dfp_parent_ad_unit_path != 0) {
                        domainParentCode = k.dfp_parent_ad_unit_path;
                    } else {
                        domainParentCode =
                            hbAmp == false
                                ? this.domain_details.parent_ad_unit_code
                                : this.domain_details.amp_parent_ad_unit_code;
                    }
                }
            }

            this.domainMcmEnabled = this.domain_details.mcm_enable;
            var domainMcmType = this.domain_details.mcm
                ? this.domain_details.mcm.account_type
                : this.domain_details.mcm;
            var domainMcmChild = this.domain_details.child_dfp_network
                ? this.domain_details.child_dfp_network.child_network_code
                : this.domain_details.child_dfp_network;
            var hbAccountType = k.mcm_account_switch;
            var hbOverridenChildNetwork = k.child_network_override;
            var adunitCode = k.dfp_ad_unit_code;
            var hbNetworkOverride = k.network_override;
            var isPubUnit = k.publisher_dfp_unit;
            var ishbNtwrkOverriden = k.network_override == null ? false : true;
            var current_dfp_network = k.current_dfp_network;

            if (isPubUnit == true) {
                if (hbAccountType) {
                    if (hbAccountType == 'MANAGE_ACCOUNT') {
                        return `${hbOverridenChildNetwork}/${adunitCode}`;
                    } else {
                        // return `${domainNetowrkCode},${hbOverridenChildNetwork}/${adunitCode}`
                        return `${current_dfp_network},${hbOverridenChildNetwork}/${adunitCode}`;
                    }
                } else {
                    if (ishbNtwrkOverriden == true || hbAmp) {
                        return `${hbNetworkOverride ? hbNetworkOverride : current_dfp_network}/${adunitCode}`;
                    } else if (current_dfp_network) {
                        return `${current_dfp_network}/${adunitCode}`;
                    } else {
                        if (this.domainMcmEnabled) {
                            if (domainMcmType == 'MANAGE_ACCOUNT') {
                                return `${domainMcmChild}/${adunitCode}`;
                            } else {
                                return `${domainNetowrkCode},${domainMcmChild}/${adunitCode}`;
                            }
                        } else {
                            return `${domainNetowrkCode}/${adunitCode}`;
                        }
                    }
                }
            } else {
                if (hbAccountType) {
                    if (hbAccountType == 'MANAGE_ACCOUNT') {
                        return `${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`;
                    } else {
                        // return `${domainNetowrkCode},${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`
                        return `${current_dfp_network},${hbOverridenChildNetwork}/${domainParentCode}/${adunitCode}`;
                    }
                }
                if (ishbNtwrkOverriden == true || hbAmp) {
                    return `${
                        hbNetworkOverride ? hbNetworkOverride : domainNetowrkCode
                    }/${domainParentCode}/${adunitCode}`;
                } else if (current_dfp_network) {
                    return `${current_dfp_network}/${domainParentCode}/${adunitCode}`;
                } else {
                    if (this.domainMcmEnabled) {
                        if (domainMcmType == 'MANAGE_ACCOUNT') {
                            return `${domainMcmChild}/${domainParentCode}/${adunitCode}`;
                        } else {
                            return `${domainNetowrkCode},${domainMcmChild}/${domainParentCode}/${adunitCode}`;
                        }
                    } else {
                        return `${domainNetowrkCode}/${domainParentCode}/${adunitCode}`;
                    }
                }
            }

            return adunitCode;
        },
        getAllAssociatedAdSpots() {
            this.loading = true;
            axios
                .get(
                    `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${this.bucketId}/adspot-tag-association/`
                )
                .then((associatedSpots) => {
                    this.allAssociatedAdSpots = this.allAssociatedAdSpots.concat(associatedSpots.data.data);
                    this.allAdSpotsWithLayouts.forEach((adSpotWithLayout) => {
                        if (this.alreadyAssociated(adSpotWithLayout)) {
                            adSpotWithLayout.alreadyAssociated = true;
                        } else {
                            adSpotWithLayout.alreadyAssociated = false;
                        }
                    });
                    this.formLoadingDone = true;
                    this.loading = false;
                });
        },
        getAdspotTagAssociation(pageNum = 1) {
            this.associatedAdSpots = [];
            this.loading = true;
            let temp = [];
            let mapper = {
                adLayout: 'layout',
                adSpotId: 'adspot',
                adIsLive: 'is_live',
                adHbAdUnit: 'hb_id',
                adDimensions: 'dimension_list',
            };
            let queryData = {};
            for (let item in mapper) {
                if (Array.isArray(this.filterData[item]) && this.filterData[item].length == 0) {
                    continue;
                }
                if (item == 'adIsLive') {
                    if (this.filterData[item] !== null) {
                        temp.push(['is_live', this.filterData[item]]);
                        queryData[item] = this.filterData[item];
                    }
                    continue;
                }
                if (this.filterData[item]) {
                    temp.push([mapper[item], this.filterData[item]]);
                    queryData[item] = this.filterData[item].join(',');
                }
            }
            this.$router.replace({ query: queryData });

            const params = new URLSearchParams(temp);

            if (this.cancelRequestMethod !== null) {
                this.cancelRequestMethod();
            }
            let axiosSource = axios.CancelToken.source();
            this.cancelRequestMethod = axiosSource.cancel;
            axios
                .get(
                    `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${this.bucketId}/adspot-tag-association/?page=${pageNum}&offset=${this.offset}`,
                    {
                        params: params,
                        cancelToken: axiosSource.token,
                    }
                )
                .then((associatedSpots) => {
                    this.currentPage = pageNum;
                    this.totalPages = associatedSpots.data.metadata.count;
                    this.associatedAdSpots = associatedSpots.data.data;
                    this.loading = false;
                })
                .catch((err) => {
                    if (axios.isCancel(err)) {
                        console.log('request cancelled successfully');
                    } else this.loading = false;
                });
        },
        clearFilter() {
            this.filterData = {
                adIsLive: null,
                adSpotId: [],
                adLayout: [],
                adDfpAdUnit: [],
                adHbAdUnit: [],
                adDimensions: [],
            };
            this.getAdspotTagAssociation();
        },

        tableRowClassName() {
            jQuery('#assoc-table').find('.warning-row').removeClass('warning-row');
            if (this.formData.index > -1)
                jQuery('#assoc-table').find('table>tbody').find('tr').eq(this.formData.index).addClass('warning-row');
        },
        editAdSpotTagAssoc(asta) {
            console.log('editAdSpotTagAssoc');
            this.loading = true;
            var index = -1;
            for (var i = 0; i < this.associatedAdSpots.length; i++)
                if (this.associatedAdSpots[i].id == asta.id) {
                    index = i;
                    break;
                }
            if (this.importedData) {
                this.$notify({
                    title: 'Error',
                    message: 'Not possible!! Save the imported data to edit data.',
                    type: 'error',
                });
                return;
            }
            let _this = this;
            this.formData.index = index;
            this.formData.id = asta.id;
            this.formData.layout = [asta.layout.id];
            this.formData.hbEnabled = asta.is_hb;
            this.formData.checkedDimensions = [];
            this.formData.is_live = asta.is_live;

            if (this.formData.hbEnabled)
                this.getHbAdunits(asta.hb_id.dfp_ad_unit_code, () => {
                    _this.formData.hbAdUnit = asta.hb_id.id;
                    let dimensions = asta.hb_id.dimensions;
                    this.formData.availableDimensions = dimensions;
                    for (let i = 0; i < dimensions.length; i++) {
                        if (this.isChecked(this.formData.index, dimensions[i].id))
                            this.formData.checkedDimensions.push(dimensions[i].id);
                    }
                    this.loading = false;
                });
            else
                this.getDfpAdunits(asta.dfp_id.ad_unit_name, () => {
                    _this.formData.dfpAdUnit = asta.dfp_id.id;
                    let dimensions = asta.dfp_id.ad_unit_size;
                    this.formData.availableDimensions = dimensions;
                    for (let i = 0; i < dimensions.length; i++) {
                        if (this.isChecked(this.formData.index, dimensions[i].id))
                            this.formData.checkedDimensions.push(dimensions[i].id);
                    }
                    this.loading = false;
                });
            this.tableRowClassName();

            const element = this.$refs['create-edit-block'];
            element && element.scrollIntoView({ behavior: 'smooth' });
        },
        deleteAdSpotTagAssoc(asta) {
            if (this.importedData) {
                this.$notify({
                    title: 'Error',
                    message: 'Not possible!! Save the imported data to delete data.',
                    type: 'error',
                });
                return;
            }

            let index = this.associatedAdSpots.indexOf(asta);
            this.$confirm('Are you sure to delete this association?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
            })
                .then(() => {
                    axios
                        .delete(
                            BASE_URL +
                                'v1/publishers/' +
                                this.uuid +
                                '/domains/' +
                                this.domId +
                                '/buckets/' +
                                this.bucketId +
                                '/adspot-tag-association/?assoc_id=' +
                                asta.id,
                            {}
                        )
                        .then((response) => {
                            if (response.data.status) {
                                console.log(response);
                                this.associatedAdSpots.splice(index, 1);
                                this.$notify({
                                    title: 'Success',
                                    message: 'Great! Association has been successfully deleted.',
                                    type: 'success',
                                });
                                for (let i = 0; i < this.allAdSpotsWithLayouts.length; i++) {
                                    if (this.allAdSpotsWithLayouts[i].id === asta.layout.id) {
                                        return (this.allAdSpotsWithLayouts[i].alreadyAssociated = false);
                                    }
                                    console.log('usable', this.allAdSpotsWithLayouts);
                                }

                                this.formData = JSON.parse(JSON.stringify(this.copyFormData));
                                this.getAllAssociatedAdSpots(1);
                                this.loadAllData();
                                this.randomNumber = Math.random();
                                this.$forceUpdate();
                            }
                        });
                })
                .catch(() => {
                    this.$notify({
                        title: 'Error',
                        message: 'Adspot Delete Canceled',
                        type: 'error',
                    });
                });
        },
        layoutTagAssociation() {
            for (var i = 0; i < this.formData.layout.length; i++) {
                axios
                    .post(
                        BASE_URL +
                            'v1/publishers/' +
                            this.uuid +
                            '/domains/' +
                            this.domId +
                            '/buckets/' +
                            this.bucketId +
                            '/adspot-tag-association/',
                        {
                            id: this.formData.id,
                            bucket_id: this.bucketId,
                            layout: this.formData.layout[i],
                            is_hb: this.formData.hbEnabled,
                            hb_id: this.formData.hbEnabled ? this.formData.hbAdUnit : undefined,
                            dfp_id: !this.formData.hbEnabled ? this.formData.dfpAdUnit : undefined,
                            dimension_ids: this.formData.checkedDimensions,
                            is_live: this.formData.is_live,
                        }
                    )
                    .then((response) => {
                        if (response.data.status) {
                            if (this.formData.id) {
                                this.associatedAdSpots[this.formData.index].is_live = response.data.data.is_live;
                                this.associatedAdSpots[this.formData.index].is_hb = response.data.data.is_hb;
                                this.associatedAdSpots[this.formData.index].hb_id = response.data.data.hb_id;
                                this.associatedAdSpots[this.formData.index].dfp_id = response.data.data.dfp_id;
                                this.associatedAdSpots[this.formData.index].dimensions = response.data.data.dimensions;
                                this.associatedAdSpots[this.formData.index].floors = response.data.data.floors;
                            } else this.associatedAdSpots.push(response.data.data);

                            for (let adspot of this.allAdSpotsWithLayouts) {
                                adspot.alreadyAssigned = false;
                            }
                            //console.log('layout: ', this.formData.layout);
                            console.log('before', this.allAdSpotsWithLayouts);
                            this.formData.layout.forEach((layout) => {
                                for (let adspot of this.allAdSpotsWithLayouts) {
                                    if (adspot.id == layout) {
                                        adspot.alreadyAssociated = true;
                                    } else {
                                        adspot.alreadyAssigned = false;
                                    }
                                }
                            });
                            console.log('after:', this.allAdSpotsWithLayouts[0]);
                            this.randomNumber = Math.random();
                            this.formData = JSON.parse(JSON.stringify(this.copyFormData));
                            this.$forceUpdate();
                            this.tableRowClassName();
                            // this.getAllAssociatedAdSpots(1);
                        }
                    });
            }
            this.$notify({
                title: 'Success',
                message: 'Ad-spot and tag has been successfully associated',
                type: 'success',
            });
            // this.formData.layout = [];
        },
        getDfpAdunits(query, callback) {
            if (query) {
                this.searchingAdUnit = true;
                axios.all([axios.get(BASE_URL + 'v1/search-ad-unit/' + this.domId + '/?query=' + query)]).then(
                    axios.spread((data) => {
                        this.searchingAdUnit = false;
                        this.dfpAdUnits = data.data;
                        // this.adUnitChange();
                        if (callback) callback();
                    })
                );
            }
        },
        getHbAdunits(query, callback) {
            if (query) {
                this.searchingAdUnit = true;
                axios.all([axios.get(BASE_URL + 'v1/search-hb-ad-unit/' + this.domId + '/?query=' + query)]).then(
                    axios.spread((data) => {
                        this.searchingAdUnit = false;
                        this.hbAdUnits = data.data;
                        // this.adUnitChange();
                        if (callback) callback();
                    })
                );
            }
        },
        getAdTypeName(fi_ad_type_id) {
            let i = 0;
            for (; i < this.fiAdTypes.length; i++) {
                if (this.fiAdTypes[i].id == fi_ad_type_id) return this.fiAdTypes[i].name;
            }
            return '-';
        },
        selectedBucket(index) {
            this.selectedBucketData = this.importBuckets[index];
            let allPages = 0;

            axios
                .get(
                    `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${
                        this.selectedBucketData.id
                    }/adspot-tag-association/?page=${1}&offset=${this.offset}`
                )
                .then((response) => {
                    // this.importedData = true;
                    allPages = Math.ceil(response.data.metadata.total / this.offset);
                    for (let i = 0; i < allPages; i++) {
                        axios
                            .get(
                                `${BASE_URL}v1/publishers/${this.uuid}/domains/${this.domId}/buckets/${
                                    this.selectedBucketData.id
                                }/adspot-tag-association/?page=${i + 1}&offset=${this.offset}`
                            )
                            .then((response) => {
                                this.importedData = true;
                                this.associatedAdSpots = this.associatedAdSpots.concat(response.data.data);
                                if (i + 1 == allPages)
                                    this.$notify({
                                        title: 'Success',
                                        message: 'Yass! Import Success! Remember to click save to save the import.',
                                        type: 'success',
                                    });
                            });
                    }
                });

            // axios.get(BASE_URL +'v1/publishers/'+ this.uuid +'/domains/'+ this.domId +'/buckets/'+ this.selectedBucketData.id +'/adspot-tag-association/')
            // .then((response) => {
            // 	this.importedData = true;
            // 	this.associatedAdSpots = response.data;
            // 	this.$notify({
            // 		title: 'Success',
            // 		message: 'Yass! Import Success! Remember to click save to save the import.',
            // 		type: 'success'
            // 	});
            // });
        },
        removeImport(message) {
            axios
                .get(
                    BASE_URL +
                        'v1/publishers/' +
                        this.uuid +
                        '/domains/' +
                        this.domId +
                        '/buckets/' +
                        this.bucketId +
                        '/adspot-tag-association/?page=1&offset=' +
                        this.offset
                )
                .then((response) => {
                    this.importedData = false;
                    this.associatedAdSpots = response.data.data;
                    this.totalPages = response.data.metadata.total;
                    this.$notify({
                        title: 'Success',
                        message: message
                            ? 'Yay! Data has been successfully imported.'
                            : 'Done! Imported data has been removed.',
                        type: 'success',
                    });
                });
        },
        saveImportedData() {
            if (!this.importedData) return;

            let tempArray = [];
            for (let i = 0; i < this.associatedAdSpots.length; i++) {
                tempArray.push({
                    layout: this.associatedAdSpots[i].layout.id,
                    is_hb: this.associatedAdSpots[i].is_hb,
                    hb_id: this.associatedAdSpots[i].hb_id.id,
                    dfp_id: this.associatedAdSpots[i].dfp_id.id,
                    dimensions: this.associatedAdSpots[i].dimensions,
                    is_live: this.associatedAdSpots[i].is_live,
                });
                let adSpotsWithLayout = this.allAdSpotsWithLayouts.filter((adSpotsWithLayout) => {
                    return adSpotsWithLayout.id == this.associatedAdSpots[i].layout.id;
                })[0];
                if (adSpotsWithLayout) adSpotsWithLayout.alreadyAssociated = true;
            }

            axios
                .post(
                    BASE_URL +
                        'v1/publishers/' +
                        this.uuid +
                        '/domains/' +
                        this.domId +
                        '/buckets/' +
                        this.bucketId +
                        '/imported-adspot-tag-assoc/',
                    {
                        data: tempArray,
                    }
                )
                .then((response) => {
                    if (response.data.status) this.removeImport(true);
                });
        },
        setUniqueOrAdFormat(adSpotId) {
            this.fakeAdSpotId = [];
            this.filterData.adSpotId = [];
            for (let tempAdId in adSpotId) {
                let currentAdspotId = adSpotId[tempAdId];
                let currentAdSpot = this.allIndividualAdspots.filter((temp) => currentAdspotId == temp.id)[0];
                if (!currentAdSpot.is_existing) {
                    this.filterData.adSpotId.push(...currentAdSpot.id_list);
                } else this.filterData.adSpotId.push(currentAdspotId);
                this.fakeAdSpotId.push(currentAdspotId);
            }
        },
        getLabel(adspot) {
            return adspot.ad_spot.alias_name + ' - ' + adspot.ad_spot.unique_id + ' - ' + adspot.layout.layout_name;
        },
        getUniqueOrAdFormat() {
            let querySet = this.allIndividualAdspots;
            let existingTypes = [];
            let typeIdMapping = {};
            let deleteIndex = [];
            for (let index in querySet) {
                index = parseInt(index);
                if (!querySet[index].is_existing) {
                    let fiType = querySet[index].fi_ad_type;
                    if (existingTypes.includes(fiType)) {
                        deleteIndex.push(index);
                        querySet[typeIdMapping[fiType]].id_list.push(querySet[index].id);
                    } else {
                        existingTypes.push(fiType);
                        typeIdMapping[fiType] = index;
                        querySet[index].id_list = [querySet[index].id];
                    }
                    this.mapAdSpotIdtoFakeIds[querySet[index].id] = querySet[typeIdMapping[fiType]].id;
                }
            }
            return querySet.filter((_, index) => !deleteIndex.includes(index));
        },
        loadAdDimensions() {
            var apidimension = BASE_URL + 'v1/ad-dimensions/';

            axios.get(apidimension).then((response) => {
                this.dimensions = response.data;
            });
        },
        alreadyAssociated(adspot) {
            // console.trace('alreadyAssociated');
            for (let i = 0; i < this.allAssociatedAdSpots.length; i++) {
                if (this.allAssociatedAdSpots[i].layout.id == adspot.id) return true;
            }
            return false;
        },
        isChecked(adspotassocIndex, dimensionId) {
            let flag = false;
            for (let i = 0; i < this.associatedAdSpots[adspotassocIndex].dimensions.length; i++) {
                if (this.associatedAdSpots[adspotassocIndex].dimensions[i].id == dimensionId) {
                    flag = true;
                    break;
                }
            }
            return flag;
        },
        adUnitChange() {
            this.formData.checkedDimensions = [];
            if (this.formData.hbEnabled) {
                let hbTag = this.hbAdUnits.filter((hbAdUnit) => {
                    if (hbAdUnit.id == this.formData.hbAdUnit) return hbAdUnit;
                })[0];
                let dimensions = hbTag.dimensions;
                this.formData.availableDimensions = dimensions;
                dimensions.forEach((dimension) => {
                    this.formData.checkedDimensions.push(dimension.id);
                });
            } else {
                // To be implemeted
                // console.log(this.adunit.ad_unit_name);
                // console.log(this.formData.dfpAdUnit);
                let dfpUnit = this.dfpAdUnits.filter((dfpAdUnit) => {
                    if (dfpAdUnit.id == this.formData.dfpAdUnit) return dfpAdUnit;
                })[0];
                // console.log(dfpUnit);
            }
        },
        isDisabled(dimensionId) {
            return (
                this.formData.checkedDimensions.length == 1 && this.formData.checkedDimensions.indexOf(dimensionId) > -1
            );
        },
        handleCurrentChange(val) {
            if (this.searchFI == '') this.getAdspotTagAssociation(val);
            else {
                this.associatedAdSpots = this.filteredAssociatedAdSpots.slice((val - 1) * 20, val * 20);
            }
        },
        handleSizeChange(val) {
            this.offset = val;
            this.getAdspotTagAssociation(1);
            this.currentPage = 1;
        },

        checkDisabled() {
            console.log('adspot', this.formData.layout);
            console.log('all', this.allAdSpotsWithLayouts);
            if (this.formData.layout.length <= 0) {
                for (let adspot of this.allAdSpotsWithLayouts) {
                    adspot.alreadyAssigned = false;
                }
            }
            for (let adspot of this.allAdSpotsWithLayouts) {
                //  console.log(adspot)
                if (adspot.id == this.formData.layout) {
                    console.log(adspot.ad_spot.alias_name);
                    let alias = adspot.ad_spot.alias_name;
                    for (let adspot2 of this.allAdSpotsWithLayouts) {
                        if (alias != adspot2.ad_spot.alias_name) {
                            adspot2.alreadyAssigned = true;
                        }
                    }
                }
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// FiTagAssociation.vue?1aa66b0d